import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AvailabilityModal from './AvailabilityModal';
import resetAvailabilityModal from '../../../actions/availability/resetAvailabilityModal';
import updateEligibility from '../../../actions/availability/updateEligibility';
import getProductIdMap from '../../../actions/availability/getProductIdMap';
import globalError from '../../../actions/globalError';

const mapStateToProps = ({ estimateBuilder }) => ({
  selectedEstimate: estimateBuilder.uiState.selectedEstimate,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      resetAvailabilityModal,
      updateEligibility,
      getProductIdMap,
      globalError,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AvailabilityModal);
